import * as React from 'react';
import proptypes from 'prop-types';
const { shape, bool } = proptypes;

export const AppError = ({ error = null, debug = false }) => {

  return (
    <div id="root__error" className="container">
      <div className="grid isBound">
        <div className="col__12-12">
          <div className="grid error-page" data-testid="errorContent">
            <div className="grid grid isBound error-page">
              <div
                className="sui-flex sui-flex-col sui-justify-center
                sui-items-center -sui-ml-3 -sui-mt-3 sui-pt-96 col__12-12"
              >
                <img
                  src="https://assets.homedepot-static.com/images/v1/oops.svg"
                  alt=""
                  className="stretchy sui-max-w-2xl"
                  width="702"
                  height="205"
                />
                <h1 className="error-page__title u__display-font--black">WE&apos;RE FIXING IT.</h1>
                <div className="error-page__description">
                  <p>We&apos;ll have this patched up as soon as possible.</p>
                </div>
                {error && debug && <pre><code>{error.toString()}</code></pre>}
                {error && debug && <pre><code>{error.stack}</code></pre>}
                <div className="sui-mb-3">
                  <a
                    className="bttn bttn--primary bttn--inline
                    u__bottom--standard body__m-right-large"
                    href="/"
                  >
                    <span className="bttn__content">Back to homepage</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AppError.propTypes = {
  error: shape({}),
  debug: bool
};